const Pagenation = ({ total, page, setPage }: any) => {
  const nextPre = () => {
    if (page === 1) {
      return;
    } else {
      setPage(page - 1);
    }
  };
  const clickPage = (i: any) => {
    setPage(i);
  };
  const nextPage = () => {
    if (page === total) {
      return;
    } else {
      setPage(page + 1);
    }
  };
  const numberList = () => {
    const pageNumberList = [];

    //몫
    var pShare = Number(page - 1) / 5;
    var t;
    var pageIndex = (pShare | 0) * 5;

    //#############################################
    t = total <= pageIndex + 5 ? total : pageIndex + 5;

    var startIndex = pageIndex < 5 ? 0 : pageIndex;
    var endIndex = t;

    for (let i = startIndex; i < endIndex; i++) {
      pageNumberList.push(
        <td
          className={page === i + 1 ? "selected-page" : ""}
          key={i}
          onClick={() => clickPage(i + 1)}
        >
          {i + 1}
        </td>
      );
    }
    return pageNumberList;
  };

  return (
    <div className="pagenation">
      <table className="pagenation-number-list-table">
        <tbody>
          <tr>
            <td
              onClick={nextPre}
              style={
                page === 1
                  ? { cursor: "default", color: "#BDBDBD", zIndex: "99" }
                  : { zIndex: "99" }
              }
            >
              이전
            </td>
            {numberList()}
            <td
              onClick={nextPage}
              style={
                page === total ? { cursor: "default", color: "#BDBDBD" } : {}
              }
            >
              다음
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default Pagenation;
